module.exports = __webpack_public_path__ + "img/box-open.3f42b18f.svg";